import { c as _c } from "react/compiler-runtime";
import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ApiProfileMin } from "@/generated/models/ApiProfileMin";
interface ArtistPreviewModalHeaderProps {
  readonly user: ApiProfileMin;
  readonly onClose: () => void;
  readonly isApp?: boolean;
  readonly currentContentType: "active" | "winners";
  readonly submissionCount: number;
  readonly winnerCount: number;
}
export const ArtistPreviewModalHeader: React.FC<ArtistPreviewModalHeaderProps> = t0 => {
  const $ = _c(39);
  const {
    user,
    onClose,
    isApp: t1,
    currentContentType,
    submissionCount,
    winnerCount
  } = t0;
  const isApp = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== currentContentType || $[1] !== user.handle) {
    t2 = () => {
      const artistName = user.handle || "Unknown Artist";
      return currentContentType === "winners" ? `${artistName}'s Won Artworks` : `${artistName}'s Submissions`;
    };
    $[0] = currentContentType;
    $[1] = user.handle;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getTitle = t2;
  let t3;
  if ($[3] !== currentContentType || $[4] !== submissionCount || $[5] !== winnerCount) {
    t3 = () => {
      const count = currentContentType === "winners" ? winnerCount : submissionCount;
      return `${count} artwork${count !== 1 ? "s" : ""}`;
    };
    $[3] = currentContentType;
    $[4] = submissionCount;
    $[5] = winnerCount;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const getCurrentCount = t3;
  const t4 = `tw-relative tw-z-[100] tw-flex tw-flex-col ${isApp ? "tw-px-6 tw-py-4" : "tw-p-6"} tw-border-b tw-border-iron-800/60 tw-border-solid tw-border-t-0 tw-border-x-0`;
  const t5 = `tw-h-12 tw-w-12 tw-flex-shrink-0 tw-rounded-lg tw-overflow-hidden tw-bg-iron-900 tw-border tw-border-solid ${currentContentType === "winners" ? "tw-shadow-[0_1px_4px_rgba(251,191,36,0.15)] tw-border-[#E4CFA1]/5" : "tw-border-white/10"}`;
  let t6;
  if ($[7] !== user.pfp) {
    t6 = user.pfp && <img src={user.pfp} alt="Profile" className="tw-w-full tw-h-full tw-object-contain tw-bg-transparent" />;
    $[7] = user.pfp;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = `tw-text-xl sm:tw-text-2xl tw-font-semibold tw-mb-1 tw-tracking-tight tw-transition-all tw-duration-300 ${currentContentType === "winners" ? "tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-amber-100 tw-via-yellow-50 tw-to-amber-100" : "tw-text-iron-100"}`;
  const t9 = getTitle();
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <div className={t8}>{t9}</div>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = getCurrentCount();
  let t12;
  if ($[15] !== t11) {
    t12 = <span>{t11}</span>;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="tw-w-1 tw-h-1 tw-rounded-full tw-bg-white/40" />;
    t14 = <span>The Memes Collection</span>;
    $[17] = t13;
    $[18] = t14;
  } else {
    t13 = $[17];
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t12) {
    t15 = <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-transition-colors tw-duration-300 tw-text-white/50">{t12}{t13}{t14}</div>;
    $[19] = t12;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t10 || $[22] !== t15) {
    t16 = <div className="tw-text-left tw-relative">{t10}{t15}</div>;
    $[21] = t10;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t16 || $[25] !== t7) {
    t17 = <div className="tw-flex sm:tw-flex-row tw-flex-col sm:tw-items-center sm:tw-gap-4 tw-gap-3">{t7}{t16}</div>;
    $[24] = t16;
    $[25] = t7;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== isApp || $[28] !== onClose) {
    t18 = !isApp && <button onClick={onClose} className="tw-flex tw-items-center tw-justify-center tw-h-10 tw-w-10 tw-flex-shrink-0 tw-rounded-full tw-bg-iron-950 tw-text-white tw-transition tw-duration-200 tw-border tw-border-solid tw-border-iron-800/70 desktop-hover:hover:tw-border-iron-700 desktop-hover:hover:tw-bg-iron-900 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-iron-600/70 active:tw-scale-95" aria-label="Close Gallery"><XMarkIcon className="tw-w-5 tw-h-5 tw-flex-shrink-0" /></button>;
    $[27] = isApp;
    $[28] = onClose;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t17 || $[31] !== t18) {
    t19 = <div className="tw-flex tw-gap-x-3 tw-justify-between">{t17}{t18}</div>;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t19 || $[34] !== t4) {
    t20 = <div className={t4}>{t19}</div>;
    $[33] = t19;
    $[34] = t4;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  const HeaderInner = t20;
  let t21;
  if ($[36] !== HeaderInner || $[37] !== currentContentType) {
    t21 = currentContentType === "winners" ? <div className="tw-relative tw-overflow-hidden"><div className={"tw-absolute tw-inset-x-0 tw-top-0 tw-h-14 tw-pointer-events-none\n      tw-bg-[linear-gradient(180deg,rgba(234,223,191,0.045),rgba(0,0,0,0)_80%)]"} /><div className={"tw-absolute tw-inset-0 tw-pointer-events-none\n      tw-bg-[linear-gradient(115deg,rgba(234,223,191,0.04)_0%,transparent_40%)]"} /><div className={"tw-absolute tw-inset-0 tw-pointer-events-none\n      tw-bg-[radial-gradient(120%_140%_at_50%_120%,rgba(0,0,0,0.22),transparent_45%)]"} /><div className="tw-absolute tw-inset-x-0 tw-bottom-0 tw-h-px tw-pointer-events-none tw-bg-white/10" />{HeaderInner}</div> : HeaderInner;
    $[36] = HeaderInner;
    $[37] = currentContentType;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  return t21;
};